module.exports = __webpack_public_path__ + "img/keyboard_H.0b5010e2.png";